type Props = {
  onRequestAccess: () => void;
};

export function Hero({ onRequestAccess }: Props) {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="container-page pt-16 pb-20 sm:pt-20 sm:pb-24">
        <div className="grid items-center gap-10 lg:grid-cols-[0.92fr_1.08fr] lg:gap-14">
          {/* Left: copy */}
          <div className="animate-fade-up">
            <p className="eyebrow mb-5">Business health, decided</p>
            <h1 className="max-w-[15ch] text-display-xl leading-[1.06] text-ink-primary">
              Your company's data, turned into decisions.
            </h1>
            <p className="mt-5 max-w-[48ch] text-[17px] leading-relaxed text-ink-secondary sm:text-[19px]">
              Claros reads your financials, people, product and market — then
              hands you a short list of decisions, each framed with the signal
              that raised it, the recommendation, and the conditions attached.
              Not another dashboard to interpret. The calls, made legible.
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3.5">
              <button
                type="button"
                onClick={onRequestAccess}
                className="btn-primary"
              >
                Request early access
              </button>
              <a href="#how" className="btn-ghost">
                See how it reads a company
              </a>
            </div>
            <p className="mt-5 font-mono text-[13px] tracking-[0.03em] text-ink-faint">
              For operators and investors · assessed continuously · every call
              is auditable
            </p>
          </div>

          {/* Right: product screenshot in a browser-style frame */}
          <figure
            className="m-0"
            style={{ animation: 'fade-up 0.7s cubic-bezier(0.2,0.7,0.2,1) 0.15s both' }}
          >
            <div className="overflow-hidden rounded-[18px] border border-border bg-bg-surface shadow-panel">
              <div className="flex items-center gap-1.5 border-b border-border-subtle px-4 py-3">
                <span className="h-2.5 w-2.5 rounded-full bg-border" />
                <span className="h-2.5 w-2.5 rounded-full bg-border" />
                <span className="h-2.5 w-2.5 rounded-full bg-border" />
                <span className="ml-3 font-mono text-[12px] text-ink-faint">
                  app.claros.pro / decisions
                </span>
              </div>
              <img
                src="/hero-decisions.png"
                alt="Claros Decisions view: four open calls this quarter — the investment call, two key-person risks and a covenant breach — each with the signal that raised it and Claros's recommendation."
                loading="eager"
                decoding="async"
                className="block h-auto w-full"
              />
            </div>
          </figure>
        </div>
      </div>
    </section>
  );
}
